module.exports = __webpack_public_path__ + "static/media/sm_seguros.495bea8c.png";